<template>
    <div class="form-input">
        <input
            ref="telInput"
            v-model="modelValue.e164Formated"
            type="tel"
            class="e164Number h-4 br b-1"
            name="corp_tel"
            @blur="formatNumber"
        />
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        otherCC() {
            return window.SmartPhoneNumber.getPreferredCountries(this.modelValue.defaultCC);
        },
    },
    watch: {
        value: function (newVal, oldVal) {
            // watch it
            if (oldVal.e164Formated === '') {
                // In case of loading component before data, we must destroy the actual input to set right country code
                this.$nextTick(() => {
                    const input = $(this.$el).find('.e164Number');
                    input.intlTelInput('destroy');
                    window.SmartPhoneNumber.prepareOneField(
                        input,
                        this.otherCC,
                        this.defaultCC,
                        true,
                    );
                });
            }
        },
    },
    mounted() {
        const input = $(this.$el).find('.e164Number');
        window.SmartPhoneNumber.prepareOneField(input, this.otherCC, this.defaultCC);
        if (this.modelValue.e164 !== '' && this.modelValue.e164Formated === '') {
            this.modelValue.e164Formated = this.modelValue.e164;
        }
    },
    methods: {
        formatNumber() {
            const input = $(this.$el).find('.e164Number');

            this.modelValue.CC = input.intlTelInput('getSelectedCountryData').iso2;
            this.modelValue.dialCode = input.intlTelInput('getSelectedCountryData').dialCode;
            this.modelValue.e164 = input.intlTelInput(
                'getNumber',
                intlTelInputUtils.numberFormat.E164,
            );
            this.modelValue.e164Formated = input.intlTelInput(
                'getNumber',
                intlTelInputUtils.numberFormat.INTERNATIONAL,
            );

            this.$emit('change', this.modelValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.form-input {
    input:focus {
        border-color: var(--colors-common-border-focus) !important;
    }
}
</style>

<style lang="scss">
.form-input .intl-tel-input {
    .country-list li {
        height: 32px;

        &:hover {
            border-radius: 5px;
        }
    }
}
</style>
